import { Component, Input } from "@angular/core";

@Component({
  selector: "li-download",
  templateUrl: "./download.component.html",
})
export class DownloadComponent {
  @Input() height = 16;
  @Input() width = 17;
}